import { render, staticRenderFns } from "./Beepiz.vue?vue&type=template&id=48b349cb&"
import script from "./Beepiz.vue?vue&type=script&lang=js&"
export * from "./Beepiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports